if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();

        this.tabs = Array.from(this.querySelectorAll('.product-tabs__tab'));
        this.panels = Array.from(this.querySelectorAll('.product-tabs__panel'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab.dataset.tab));
        });

        // Description is open by default on every screen size. The markup
        // (snippets/product-tabs.liquid) already renders it active, so it is
        // visible before this script runs; select() here only keeps the
        // state consistent. Size & Fit / Shipping & Returns stay closed
        // until clicked.
        this.select('description');
      }

      select(name) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.tab === name;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active);
        });
        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.panel === name);
        });
      }
    }
  );
}
